import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {NOTIFICATION_VARIANTS} from '@nur-portal/ui-kit';

import {addJitsuProperty} from '../../../../../../services/analytics/jitsu-helpers';
import {showNotification} from '../../../../../../website-ui/components/notification-center/helpers';
import {NicknameForm} from '../../../../../../website-ui/forms/nickname';
import {isCommonError} from '../../../../../../website-ui/helpers/common-error';
import {updatePersonalData} from '../../../../../../website-ui/helpers/personal-data';
import {refreshUserToken} from '../../../../../../website-ui/helpers/refresh-user-token';

const StepNickname = ({
  onSubmitClick = () => {},
  onCancelClick = () => {},
  onSuccess = () => {}
}) => {
  const {t} = useTranslation('');
  const [nicknameError, setNicknameError] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const formErrorCallback = () => {};

  const formSubmitCallback = async ({nickname}) => {
    setIsLoading(true);
    await refreshUserToken(false);
    await updatePersonalData(
      {username: nickname},
      () => {
        setIsLoading(false);
        showNotification({
          variant: NOTIFICATION_VARIANTS.SUCCESS,
          text: t('forms:nickname.notifications.success')
        });
        onSuccess();
        addJitsuProperty('user_has_nickname', true);
        refreshUserToken();
      },
      error => {
        setIsLoading(false);
        if (isCommonError(error.code)) {
          showNotification({
            variant: NOTIFICATION_VARIANTS.ALERT,
            text: t(`errors:common.${error.code}`)
          });
        } else {
          setNicknameError(error);
        }
      }
    );
  };

  return (
    <>
      <NicknameForm
        formErrorCallback={formErrorCallback}
        formSubmitCallback={formSubmitCallback}
        responseError={nicknameError}
        isLoading={isLoading}
        onSubmitClick={onSubmitClick}
        onCancelClick={onCancelClick}
      />
    </>
  );
};

export {StepNickname};
